/** Strip sq.ft / sqft / square feet from area range so the form suffix is not duplicated. */
export const stripAreaSqFtUnit = (value) => {
  if (value == null) return '';
  return String(value)
    .replace(/\s*(sq\.?\s*ft\.?|sqft|square\s*feet)\s*/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

/** Display area range with unit, e.g. "650 - 1200 sq.ft". */
export const formatAreaRangeWithSqFt = (value) => {
  const cleaned = stripAreaSqFtUnit(value);
  if (!cleaned) return null;
  return `${cleaned} sq.ft`;
};
